import React from 'react';
import { ReactNode } from 'react';

import clsx from 'clsx';
import SouthIcon from '@mui/icons-material/South';
import NorthIcon from '@mui/icons-material/North';

import styles from './TableHeadCell.module.scss';

interface TableHeadCellProps {
  children: ReactNode;
  isSorted: boolean;
  currentSort: boolean;
  isSortedDesc?: boolean;
  onClick?: () => void;
  className?: string;
  isExist?: boolean;
}

const TableHeadCell = ({
  children,
  isSorted,
  isSortedDesc,
  className,
  onClick,
  currentSort,
  isExist = true,
}: TableHeadCellProps) => {
  const renderArrow = () => {
    if (!isSorted) {
      return null;
    }

    if (currentSort) {
      if (isSortedDesc) {
        return <SouthIcon sx={{ fontSize: 16 }} className={currentSort ? styles.sortedArrow : styles.arrow} />;
      } else {
        return <NorthIcon sx={{ fontSize: 16 }} className={currentSort ? styles.sortedArrow : styles.arrow} />;
      }
    } else {
      return <SouthIcon sx={{ fontSize: 16 }} className={currentSort ? styles.sortedArrow : styles.arrow} />;
    }
  };

  if (!isExist) {
    return <></>;
  }

  return (
    <div
      className={clsx(styles.tableHeadCell, { [styles.sortable]: isSorted, [styles.sorted]: currentSort }, className)}
      onClick={onClick}
    >
      {children}
      {renderArrow()}
    </div>
  );
};

export default TableHeadCell;
